<template>
  <div>
    <pn-modal label="Add Key Value" @close="onClose" :open="open">
      <div :class="[{ spinner: showSpinner }]">
        <pn-spinner size="3" v-show="showSpinner" />
      </div>
      <form class="modal-default">
        <pn-input label="Key" name="Key" v-model="key"></pn-input>
        <pn-input label="Value" name="Value" v-model="value"></pn-input>
      </form>
      <div slot="buttons">
        <pn-button label="Save" @click="onConfirm"></pn-button>
      </div>
    </pn-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, toRefs } from "vue";

const key = ref("");
const value = ref("");

const props = withDefaults(
  defineProps<{
    open: boolean;
    showSpinner: boolean;
  }>(),
  {
    open: false,
    showSpinner: false,
  },
);

const { open, showSpinner } = toRefs(props);

const emit = defineEmits<{
  (e: "onClose"): void;
  (e: "onConfirm", newConfig: any): void;
}>();

const onClose = () => {
  emit("onClose");
};
const onConfirm = () => {
  emit("onConfirm", { [key.value]: value.value });
  reset();
};

const reset = () => {
  key.value = "";
  value.value = "";
};
</script>

<style scoped></style>
